import sailsIOClient from 'sails.io.js';
import socketIOClient from 'socket.io-client';
// const BASE_URL = 'http://localhost:1337';
const BASE_URL = 'https://viewnet-admin.link/';

// 1. Wrap the socket.io client with the Sails helper
const io = sailsIOClient(socketIOClient);

// 2. Configure once, before anyone uses it
io.sails.url = BASE_URL;
io.sails.query = 'roomId=notification-room'
io.sails.initialConnectionHeaders = { transports: ['websocket'], origin:'http://localhost:3000' }
// If your backend expects extra handshake data (see your screenshot):
// io.sails.query = 'roomId=ed6df3c8b-fcf8-40a3-a137-3c4be6bbf70e';
export const socket = io.sails.connect(); 

// 3. Export the pre-configured instance
export default io;